import { Component } from '@angular/core';
import { JobLogComponent } from '../../check/job-log/job-log.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-log-img-cell-render',
    templateUrl: './log-img-cell-render.component.html',
    styleUrls: ['./log-img-cell-render.component.scss'],
    standalone: false // NOSONAR
})
export class LogImgCellRenderComponent {
  public params: any;

  constructor(public dialog: MatDialog){}

	agInit(params: any): void {
		this.params = params;
  }

  jobLogPopup(){
     this.dialog?.open(JobLogComponent, { width: '619px', height:'400px' ,data : {
       jobId: this.params.data.jobId,
       
     }});
  }
}
